import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, LOCALE_ID, inject } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

// import { AgmCoreModule } from '@agm/core';

import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { routing } from './app.routing';

import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { AppSettings } from './app.settings';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { AppConfigService } from './shared/services/app-config.service';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi, HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ToasterModule } from 'angular2-toaster';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoginComponent } from './pages/login/login.component';
import { JwtModule,JWT_OPTIONS  } from '@auth0/angular-jwt';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { LogoutComponent } from './pages/logout/logout.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { TokenInterceptor } from './shared/interceptors/token-interceptor';
import { PersonalSettingsComponent } from './pages/personal-settings/personal-settings.component';
import { AccountingComponent } from './pages/accounting/accounting/accounting.component';
import { InfoBannerComponent } from './pages/info-banner/info-banner.component';
import { QflexWorkloadSettingsComponent } from './pages/qflex-workload-settings/qflex-workload-settings.component';
import { HolidayImportComponent } from './pages/holiday/holiday-import/holiday-import.component';
import { JoyrideModule } from 'ngx-joyride';
import { ShiftAppointmentsDialogComponent } from './shared/components/shift-appointments-dialog/shift-appointments-dialog/shift-appointments-dialog.component';

// import {ResponseInterceptor, ResponseInterceptorFn} from '../../node_modules/schauf-response-handler/src/lib/response-interceptor';
// import {ResponseInterceptor, ResponseInterceptorFn} from '@angular/core';
import { HistoryComponent } from './pages/history/history.component';
import { AuthService } from './auth/auth.service';
import { AuthResponseData } from './shared/models/authentication/auth-response-data';
import { catchError, of, tap } from 'rxjs';
import { FooterComponent } from './theme/components/footer/footer.component';
export function HttpLoaderFactory(http: HttpClient) {
  
  return new TranslateHttpLoader(http,'./assets/i18n/','.json');
}

export function appInitializerFn(appConfig: AppConfigService) {
  return () => {
    return appConfig.loadAppConfig();
  };
}
export function tokenGetter() {
  return localStorage.getItem('AppointmentManagementUser');
}
 
export const tokenInterceptor :HttpInterceptorFn = (req, next) =>
{
    const excludes = "/api/authentication/token";
    let authService = inject(AuthService);
    let authResponseData: AuthResponseData = authService.getCurrentUserData()
    if (req.url.search(excludes) === -1 && authResponseData !== null) {
    let token = authResponseData.appointmentManagemantToken;
      let jsonReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next(jsonReq);
    }
    return next(req);
}

export const responseInterceptorFn:HttpInterceptorFn = (request, next) =>
{
    const toasterService = inject(ToastrService);
    const translatorService = inject(TranslateService);

    return next(request).pipe(
        tap( response => 
        {
            try
            {
                let evt = <HttpResponse<any>> response;
                const message = evt.headers.get("Message");
                const type = evt.headers.get("Type");
                if (type !== null && type !== undefined && message !== null && message !== undefined)
                {
                    switch (type)
                    {
                        case "Ok":
                            translatorService.get(message).subscribe(translatedMessage => 
                            {
                                toasterService.success(translatedMessage, "", { positionClass: 'toast-top-center' });
                            }).unsubscribe();
                            break;

                        case "Information":
                            translatorService.get(message).subscribe(translatedMessage => 
                            {
                                toasterService.info(translatedMessage, "", { positionClass: 'toast-top-center' });
                            }).unsubscribe();
                            break;
                    }
                }
            }
            catch
            {
            }
           
        }),
        catchError((error: any) => 
        {
            try
            {
                const err = <HttpErrorResponse>error;

                if (err.headers != null && err.headers != undefined)
                {
                    const message = err.headers.get("Message");
                    const type = err.headers.get("Type");

                    if (type !== null && type !== undefined && message !== null && message !== undefined)
                    {
                        switch (type)
                        {
                            case "Warning":
                                translatorService.get(message).subscribe(translatedMessage => 
                                {
                                    toasterService.warning(translatedMessage, "", { positionClass: 'toast-top-center' });
                                }).unsubscribe();
                                break;

                            default:
                                translatorService.get(message).subscribe(translatedMessage => 
                                {
                                    toasterService.error(translatedMessage, "", { positionClass: 'toast-top-center' });
                                }).unsubscribe();
                                break;
                        }
                    }
                }
                return of(error);
            }
            catch
            {
                return of(error);
            }
        })
    );
}

@NgModule({
    imports: [
        //AppointmentViewModule, asd
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        PipesModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-bottom-center',
            preventDuplicates: true,
        }),
        routing,
        // No longer works SlimLoadingBarModule,
        ToasterModule,
        NgxMaterialTimepickerModule,
        JoyrideModule.forRoot(),
        NgbModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                allowedDomains: ['localhost:4200']
            }
        }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    declarations: [
        AppComponent,
        PagesComponent,
        NotFoundComponent,
        ErrorComponent,
        SidenavComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        FlagsMenuComponent,
        ApplicationsComponent,
        MessagesComponent,
        UserMenuComponent,
        LoginComponent,
        LogoutComponent,
        FooterComponent
    ],
    exports: [],
    providers: [
        provideHttpClient(withInterceptors([tokenInterceptor, responseInterceptorFn])),
        AppConfigService,
        AppSettings,
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: TokenInterceptor,
        //     multi: true
        // },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: ResponseInterceptor,
        //     multi: true
        // },
        
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFn,
            multi: true,
            deps: [AppConfigService]
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


registerLocaleData(localeDe, 'de-De', localeDeExtra);